import * as React from "react"

const SvgEmail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4 20.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18.714v-12q0-.086.006-.168L2 6.539h.007q.057-.714.58-1.237A1.93 1.93 0 0 1 4 4.714h16q.824 0 1.413.588.523.524.58 1.237H22l-.006.007q.006.083.006.168v12a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm15.255-14H4.745L12 11.04zM4 8.59l6.975 4.175q.475.276 1.025.275.55 0 1.025-.275L20 8.59v10.125H4z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgEmail
